import { Toolbar } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Routes from "../../constants/routes";
import styles from "./toolbar.module.css";
import { useSelector } from "react-redux";
import { selectCompany } from "../../reducers/companySlice";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { Badge } from "react-bootstrap";

const ModuleWebToolbar = () => {
  const company = useSelector(selectCompany);

  return (
    <Toolbar className={styles.toolbar}>
      <div>
        <div className={styles.navContainer}>
          <div>
            <Link
              component={RouterLink}
              to={`${Routes.HOME.path}`}
              style={{
                textDecoration: "none",
                marginLeft: 0,
              }}
            >
              <h6 className={styles.goBack}>
                <span className={styles.arrowIcon}>
                  <Arrow />
                </span>
                Regresar
              </h6>
            </Link>
          </div>
          <div>
            <div className={styles.verticalDivider} />
          </div>
          <div>
            <h6 className={styles.name}>
              Nombre de la tienda:{" "}
              <span>
                <p style={{ fontWeight: 400, marginLeft: 5, marginBottom: 0 }}>
                  {" "}
                  {company.Name}
                </p>
              </span>
            </h6>
          </div>
        </div>
      </div>
      <div
        className={styles.logoSVGContainer}
        style={{
          backgroundColor: "black",
        }}
      ></div>
      <div>
        <div className={styles.informationContainer}>
          <div>
            <a
              href="https://wa.me/56958765629?text=%C2%A1Hola!%20Tengo%20una%20duda%20con%20la%20plataforma."
              rel="noopener noreferrer"
              target="_blank"
            >
              <button className={styles.linkBtn}>
                Agendar una video-llamada con un diseñador(a)
              </button>
            </a>
          </div>
          <div>
            <div className={styles.verticalDivider} />
          </div>
          <div>
            <h6 className={styles.informationLabel}>
              Atención
              <span>
                <Badge
                  overlap="circular"
                  badgeContent=" "
                  variant="dot"
                  color="secondary"
                >
                  <NotificationsIcon style={{ color: "#364153" }} />
                </Badge>
              </span>
            </h6>{" "}
          </div>
        </div>
      </div>
    </Toolbar>
  );
};

const Arrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 8L2 12L6 16" />
    <path d="M2 12H22" />
  </svg>
);

export default ModuleWebToolbar;
